import React from 'react';
import './Loader.scss';

function Loader() {
  return (
    <div className="Loader">
      <div className="Loader-spinner"></div>
    </div>
  );
}

export default Loader;
